// The point table (control/score.js:26-44), bounds and the win bonus (.ai/game-rules.md "Scoring").
import type { ScoreKind } from './types';

export const POINTS: Record<ScoreKind, number> = {
  waste_to_foundation: 10,
  waste_to_tableau: 5,
  tableau_to_foundation: 10,
  tableau_to_tableau: 5,
  foundation_to_tableau: -15,
  foundation_to_foundation: 0,
  // Pyramid (owner 2026-10-24: "prosto, jak w innych grach"): a pair +10, a King alone +5
  pair: 10,
  king: 5,
  none: 0,
};

/** Mahjong: each use of the hint (owner 2026-10-24: a pair the hint found earns nothing, so a race of hints does not
 *  climb the rankings). An undo does not give it back. */
export const HINT_PENALTY = 10;

/** Timed scoring: -2 at every full 10 s of running game time. */
export const TICK_PENALTY = 2;
export const TICK_PENALTY_EVERY = 10;

export const SCORE_MAX = 9999;
/** Legacy jumped to +9999 at -9999 (Q1); the rewrite clamps instead. */
export const SCORE_MIN = -9999;
export const MOVES_MAX = 999;

export const clampScore = (n: number): number => Math.max(SCORE_MIN, Math.min(SCORE_MAX, n));
export const clampMoves = (n: number): number => Math.max(0, Math.min(MOVES_MAX, n));

/** Timed only, when time <= 1000 s: floor(1000 / max(time / 10, 5)) (window/statsWin.js:241-266). */
export function winBonus(scoring: 'standard' | 'timed', seconds: number): number {
  if (scoring !== 'timed' || seconds > 1000) return 0;
  return Math.floor(1000 / Math.max(seconds / 10, 5));
}

/** Number of 10 s marks crossed when the game time goes from `from` to `to` seconds. */
export function penaltyTicksBetween(from: number, to: number): number {
  return Math.floor(to / TICK_PENALTY_EVERY) - Math.floor(from / TICK_PENALTY_EVERY);
}
